import { useAuthLayoutContext } from "../../context/AuthLayoutContext";

const OnlineCircle = ({ userId, size = "small" }) => {
  const { orgList } = useAuthLayoutContext();

  const member = orgList?.find((org) => org?.userCode === userId);

  if (!member?.online) return null;

  const sizeCss = () => {
    switch (size) {
      case "small":
        return "h-4 w-4 left-[26px] top-[26px]";
      case "medium":
        return "h-4 w-4 left-[34px] top-[34px]";
      case "big":
        return "h-6 w-6 left-[65px] top-[65px]";
      default:
        return "h-4 w-4 left-[26px] top-[26px]";
    }
  };

  return (
    <div
      className={`absolute z-[1] rounded-full border-2 border-[white] bg-[#24832c] 
      ${sizeCss()}`}
    />
  );
};

export { OnlineCircle };
